export const CHANNEL_ID_LIST = {
    COM: "5dfcf21894e80144c1777058",
    // COM_CN: "5dfcf21894e80144c1777058",
    // HEALTH: "5dfcf21894e80144c1777058",
    NET: "6046269145d0b54da48edf5e",
    // CPAAS: "6046269145d0b54da48edf5e",
    // ORG: "6046269145d0b54da48edf5e"
};